import { WorldCountry } from '../types';

export const finlandExpanded: WorldCountry = {
  code: 'FI',
  name: 'Finland',
  slug: 'finland',
  population: 5540000,
  topCities: [
    // Major cities (keeping existing ones)
    { name: 'Helsinki', slug: 'helsinki', population: 658864 },
    { name: 'Espoo', slug: 'espoo', population: 292796 },
    { name: 'Tampere', slug: 'tampere', population: 244029 },
    { name: 'Vantaa', slug: 'vantaa', population: 239216 },
    { name: 'Oulu', slug: 'oulu', population: 208939 },
    { name: 'Turku', slug: 'turku', population: 194244 },
    { name: 'Jyväskylä', slug: 'jyvaskyla', population: 143420 },
    { name: 'Lahti', slug: 'lahti', population: 119450 },
    { name: 'Kuopio', slug: 'kuopio', population: 119615 },
    { name: 'Pori', slug: 'pori', population: 83796 },
    
    // Extended cities to reach 100
    { name: 'Kouvola', slug: 'kouvola', population: 81854 },
    { name: 'Joensuu', slug: 'joensuu', population: 76567 },
    { name: 'Lappeenranta', slug: 'lappeenranta', population: 72801 },
    { name: 'Hämeenlinna', slug: 'hameenlinna', population: 67794 },
    { name: 'Vaasa', slug: 'vaasa', population: 67749 },
    { name: 'Seinäjoki', slug: 'seinajoki', population: 63559 },
    { name: 'Rovaniemi', slug: 'rovaniemi', population: 63612 },
    { name: 'Mikkeli', slug: 'mikkeli', population: 53324 },
    { name: 'Kotka', slug: 'kotka', population: 51819 },
    { name: 'Salo', slug: 'salo', population: 51685 },
    { name: 'Porvoo', slug: 'porvoo', population: 50963 },
    { name: 'Kokkola', slug: 'kokkola', population: 47827 },
    { name: 'Hyvinkää', slug: 'hyvinkaa', population: 46598 },
    { name: 'Lohja', slug: 'lohja', population: 46458 },
    { name: 'Järvenpää', slug: 'jarvenpaa', population: 45421 },
    { name: 'Rauma', slug: 'rauma', population: 39602 },
    { name: 'Tuusula', slug: 'tuusula', population: 39243 },
    { name: 'Kirkkonummi', slug: 'kirkkonummi', population: 39049 },
    { name: 'Kajaani', slug: 'kajaani', population: 37291 },
    { name: 'Kerava', slug: 'kerava', population: 36446 },
    { name: 'Savonlinna', slug: 'savonlinna', population: 34778 },
    { name: 'Nokia', slug: 'nokia', population: 33883 },
    { name: 'Riihimäki', slug: 'riihimaki', population: 29329 },
    { name: 'Varkaus', slug: 'varkaus', population: 20390 },
    { name: 'Forssa', slug: 'forssa', population: 17390 },
    { name: 'Heinola', slug: 'heinola', population: 17368 },
    { name: 'Tornio', slug: 'tornio', population: 21712 },
    { name: 'Kemi', slug: 'kemi', population: 20423 },
    { name: 'Raisio', slug: 'raisio', population: 24663 },
    { name: 'Keminmaa', slug: 'keminmaa', population: 8420 },
    { name: 'Tervakoski', slug: 'tervakoski', population: 4654 },
    { name: 'Nastola', slug: 'nastola', population: 15021 },
    { name: 'Iisalmi', slug: 'iisalmi', population: 21684 },
    { name: 'Valkeakoski', slug: 'valkeakoski', population: 20804 },
    { name: 'Hamina', slug: 'hamina', population: 19729 },
    { name: 'Pieksämäki', slug: 'pieksamaki', population: 18872 },
    { name: 'Lieksa', slug: 'lieksa', population: 11459 },
    { name: 'Nurmes', slug: 'nurmes', population: 7834 },
    { name: 'Outokumpu', slug: 'outokumpu', population: 6745 },
    { name: 'Ylivieska', slug: 'ylivieska', population: 15084 },
    { name: 'Raahe', slug: 'raahe', population: 25544 },
    { name: 'Oulainen', slug: 'oulainen', population: 7749 },
    { name: 'Haapajärvi', slug: 'haapajarvi', population: 7070 },
    { name: 'Nivala', slug: 'nivala', population: 10734 },
    { name: 'Kalajoki', slug: 'kalajoki', population: 12705 },
    { name: 'Pietarsaari', slug: 'pietarsaari', population: 19491 },
    { name: 'Uusikaarlepyy', slug: 'uusikaarlepyy', population: 7417 },
    { name: 'Kristiinankaupunki', slug: 'kristiinankaupunki', population: 6708 },
    { name: 'Kaskinen', slug: 'kaskinen', population: 1226 },
    { name: 'Närpiö', slug: 'narpio', population: 9462 },
    { name: 'Maalahti', slug: 'maalahti', population: 5449 },
    { name: 'Mustasaari', slug: 'mustasaari', population: 18994 },
    { name: 'Korsnäs', slug: 'korsnas', population: 2141 },
    { name: 'Larsmo', slug: 'larsmo', population: 5508 },
    { name: 'Pedersören kunta', slug: 'pedersoren-kunta', population: 11089 },
    { name: 'Kruunupyy', slug: 'kruunupyy', population: 6847 },
    { name: 'Luoto', slug: 'luoto', population: 4954 },
    { name: 'Ähtäri', slug: 'ahtari', population: 5758 },
    { name: 'Alajärvi', slug: 'alajarvi', population: 9439 },
    { name: 'Evijärvi', slug: 'evijarvi', population: 2586 },
    { name: 'Ilmajoki', slug: 'ilmajoki', population: 12305 },
    { name: 'Isojoki', slug: 'isojoki', population: 2213 },
    { name: 'Jalasjärvi', slug: 'jalasjarvi', population: 7679 },
    { name: 'Karijoki', slug: 'karijoki', population: 1414 },
    { name: 'Kauhajoki', slug: 'kauhajoki', population: 13418 },
    { name: 'Kauhava', slug: 'kauhava', population: 15678 },
    { name: 'Kuortane', slug: 'kuortane', population: 3802 },
    { name: 'Kurrikka', slug: 'kurrikka', population: 13727 },
    { name: 'Lappajärvi', slug: 'lappajarvi', population: 3158 },
    { name: 'Lapua', slug: 'lapua', population: 14530 },
    { name: 'Soini', slug: 'soini', population: 2263 },
    { name: 'Teuva', slug: 'teuva', population: 5595 },
    { name: 'Töysä', slug: 'toysa', population: 3093 },
    { name: 'Vimpeli', slug: 'vimpeli', population: 2974 },
    { name: 'Ylihärmä', slug: 'yliharma', population: 2608 },
    { name: 'Ylistaro', slug: 'ylistaro', population: 5285 },
    { name: 'Keuruu', slug: 'keuruu', population: 9945 },
    { name: 'Jämsä', slug: 'jamsa', population: 20781 },
    { name: 'Jämsänkoski', slug: 'jamsankoski', population: 6846 },
    { name: 'Korpilahti', slug: 'korpilahti', population: 4883 },
    { name: 'Kuhmoinen', slug: 'kuhmoinen', population: 2240 },
    { name: 'Kyyjärvi', slug: 'kyyjarvi', population: 1369 },
    { name: 'Laukaa', slug: 'laukaa', population: 18835 },
    { name: 'Luhanka', slug: 'luhanka', population: 738 },
    { name: 'Multia', slug: 'multia', population: 1763 },
    { name: 'Muurame', slug: 'muurame', population: 10270 },
    { name: 'Petäjävesi', slug: 'petajavesi', population: 3945 },
    { name: 'Pihtipudas', slug: 'pihtipudas', population: 4074 },
    { name: 'Pylkönmäki', slug: 'pylkonmaki', population: 934 },
    { name: 'Saarijärvi', slug: 'saarijarvi', population: 9297 },
    { name: 'Toivakka', slug: 'toivakka', population: 2434 },
    { name: 'Uurainen', slug: 'uurainen', population: 3419 },
    { name: 'Viitasaari', slug: 'viitasaari', population: 6726 },
    { name: 'Äänekoski', slug: 'aanekoski', population: 18291 },
    { name: 'Konnevesi', slug: 'konnevesi', population: 2771 },
    { name: 'Sumiainen', slug: 'sumiainen', population: 1183 }
  ]
};
